export default __webpack_public_path__ + "assets/3f09d5b5ec89ed553b73e6a38c4782da.png";